//* This page is available just for the system_admin role.
//* There are buttons which perform single actions.

import React from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import _ from 'lodash'
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'
// import API from 'mg-api-node'

import { getAddinConfig, getConvertedURL, geotabAuthentication, constants } from '../../helpers/helperGeotab'
import { getGeotabCompanies } from '../../../action/GeotabActions'
import CustomButton from '../../CustomButton';

const addinConfig = getAddinConfig()

const geotabCall = (api, method, params) => {
	return new Promise((resolve, reject) => {
		api.call(method, params, resolve, reject);
	});
};

const handleAddInClick = async (event, type, toggleLoader) => {
	toggleLoader(true);

	try {
		const res = await getGeotabCompanies({ get_password: true })
		const fleets = res?.data?.response?.geotab_companies
		console.log('!handleAddInClick found fleets: ', fleets.length)

		if (!fleets || !Array.isArray(fleets)) {
			throw new Error('Invalid fleet response');
		}

		const func = type === 'notifs' ? updateGeotabWebRequest : updateGeotabAddIn;

		for (const fleet of fleets) {
			await func(fleet, toggleLoader);
		}
	} catch (error) {		
		console.log('!handleAddInClick error: ', error)
		toastr.error('Error updating add-ins')
	} finally {
		toggleLoader(false)
	}
}

//* When developper updated the mygeotab -> Administration -> System Settings -> Add-Ins
const updateGeotabAddIn = async (fleet, toggleLoader) => {
	console.log('!FLEET updateGeotabAddIn: ', fleet)
	const data = { ...fleet, fleet_token: fleet.token, sessionId: fleet.session_id }

	if (!data.email || !data.password || !data.database || !data.path || !data.fleet_token) {
		console.log('!updateGeotabAddIn Error: Incomplete fleet info')
		return
	}

	const resultAuth = await geotabAuthentication(data)
	if (resultAuth.error) {
		toastr.error(i18n.t('errorMessage.errDescription'))
		return
	}

	const { geotabApi, geotabData } = resultAuth
	data.path = geotabData.path
	data.database = geotabData.database
	data.sessionId = geotabData.sessionId

	try {
		const resGet = await geotabCall(geotabApi, 'Get', { typeName: 'AddIn' })

		let systemAddinExist = false
		resGet.forEach((addin, i) => {
			if (addin.configuration.name === 'Dual-Vision Video Camera') {
				systemAddinExist = i
			}
		})

		await geotabCall(geotabApi, systemAddinExist ? 'Set' : 'Add', {
			typeName: 'AddIn',
			// entity: { configuration: JSON.stringify(addinConfig) },
			entity: { configuration: addinConfig },
		});
		console.log('!updateGeotabAddIn Set SystemSettings res: ', data.email, data)

		// In Geotab, Clearances are permission sets (like roles) that define what users can access.
		// Each clearance has a list of Security Identifiers that grant access to specific actions or data.
		// When we add a new Security Identifier, by default, it is not automatically included in existing clearances — Geotab user needs to explicitly add it. 
		// Once the add-in settings and new  Security Identifiers pushed to Geotab we can enable (bt default) the new Security Identifiers for existing Clearances.
		if (!_.isEmpty(constants.NEW_SECURITYIDS_ENABLED)) {
			await enableSecurityIdForExistingClearances(geotabApi)
		}

		toastr.success('Success', i18n.t('components.adminSingleActions.credentialsSaved'))
	} catch (err) {
		console.error('!updateGeotabAddIn Set SystemSettings error: ', err);
	} finally {
		console.log('updateGeotabAddIn DONE')
	}
}

const enableSecurityIdForExistingClearances = async (geotabApi) => {
	console.group('enableSecurityIdForExistingClearances: ', constants.NEW_SECURITYIDS_ENABLED);

	try {
		const clearances = await geotabCall(geotabApi, 'Get', {
			typeName: 'Group',
			search: { id: 'GroupSecurityId' },
		});
		console.log('Clearances: ', clearances);

		const updatedGroups = [];

		for (const clearance of clearances) {
			let updated = false;
			// Ensure securityFilters array exists
			clearance.securityFilters = clearance.securityFilters || [];
			// Update existing entry or flag to add new one
			clearance.securityFilters = clearance.securityFilters.map(filter => {
				if (constants.NEW_SECURITYIDS_ENABLED.includes(filter.securityId.name) && filter.isAdd === false) {
					updated = true
					return { ...filter, isAdd: true }
				}
				return filter
			})

			if (updated) {
				updatedGroups.push(clearance)
			}
		}
		console.log('enableSecurityIdForExistingClearances updatedGroups: ', updatedGroups)

		// Now push updated groups
		let updatedCount = 0
		for (const group of updatedGroups) {
			await geotabCall(geotabApi, 'Set', {
				typeName: 'Group',
				entity: group,
			})
			console.log(`Updated group: ${group.name}`)
			updatedCount++
			if (updatedCount === updatedGroups.length) {
				console.log("All groups updated.")
			}			
		}
	} catch (err) {
		console.error('enableSecurityIdForExistingClearances error: ', err);
		throw err;
	} finally {
		console.groupEnd('enableSecurityIdForExistingClearances Done')
	}

}

//* When developper updated the mygeotab -> Rules -> Notification templates
const updateGeotabWebRequest = async (fleet, toggleLoader) => {
	console.log('!updateGeotabWebRequest', fleet)
	const data = { ...fleet, fleet_token: fleet.token, sessionId: fleet.session_id }
	if (!data.email || !data.password || !data.database || !data.path || !data.fleet_token) {
		console.log('!Error: empty fleet')
		return
	}

	const resultAuth = await geotabAuthentication(data)
	if (resultAuth.error) {
		toggleLoader(false);
		toastr.error(i18n.t('errorMessage.errDescription'));
		return;
	}

	const { geotabApi, geotabData } = resultAuth
	data.path = geotabData.path
	data.database = geotabData.database
	data.sessionId = geotabData.sessionId

	// const api = new API(data.email, data.password, data.database, 'my.geotab.com')
	// const api = new API(data.email, data.password, data.database, data.path)
	// api.authenticate((err, resAuth) => {

	// 	if (err) {
	// 		toggleLoader(false);
	// 		console.log('!Authenticate error:', data.email, err)

	// 		return
	// 	}

	// if (resAuth.path && resAuth.credentials && resAuth.credentials.database) {
	// 	data.path = resAuth.path
	// 	data.database = resAuth.credentials.database
	// 	data.sessionId = resAuth.credentials.sessionId

	geotabApi.call('GetNotificationWebRequestTemplates', {},
		(resCall) => {
			toggleLoader(false);

			const notificationWebRequests = resCall
			let notif_snapshot_exist_id = false;
			let notif_video_exist_id = false;
			let notif_snapshot_and_video_exist_id = false;
			let multicalls = []

			notificationWebRequests.map((notification, i) => {
				console.log('notification.name', notification.name)

				if (notification.name === 'Auto-upload snapshot to RoscoLive' && !notif_snapshot_exist_id) {
					notif_snapshot_exist_id = notification.id
				} else if (notification.name === 'Auto-upload video to RoscoLive' && !notif_video_exist_id) {
					notif_video_exist_id = notification.id
				} else if (notification.name === 'Auto-upload snapshot and video clip to RoscoLive' && !notif_snapshot_and_video_exist_id) {
					notif_snapshot_and_video_exist_id = notification.id
				}
			})

			if (notif_snapshot_and_video_exist_id) {
				multicalls.push(
					['Set', {
						typeName: 'NotificationBinaryFile',
						entity: {
							id: notif_snapshot_and_video_exist_id,
							url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/all'),
							name: 'Auto-upload snapshot and video clip to RoscoLive',
							requestType: 'Post',
							postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
							type: 'WebRequestTemplate',
						},
						credentials: {
							database: data.database,
							userName: data.email,
							sessionId: data.sessionId,
						},
					}],
				)
			} else {
				multicalls.push(
					['Add', {
						typeName: 'NotificationBinaryFile',
						entity: {
							url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/all'),
							name: 'Auto-upload snapshot and video clip to RoscoLive',
							requestType: 'Post',
							postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
							type: 'WebRequestTemplate',
						},
						credentials: {
							database: data.database,
							userName: data.email,
							sessionId: data.sessionId,
						},
					}],
				)
			}

			if (notif_snapshot_exist_id) {
				multicalls.push(
					['Set', {
						typeName: 'NotificationBinaryFile',
						entity: {
							id: notif_snapshot_exist_id,
							url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/snapshots'),
							name: 'Auto-upload snapshot to RoscoLive',
							requestType: 'Post',
							postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
							type: 'WebRequestTemplate',
						},
						credentials: {
							database: data.database,
							userName: data.email,
							sessionId: data.sessionId,
						},
					}],
				)
			} else {
				multicalls.push(
					['Add', {
						typeName: 'NotificationBinaryFile',
						entity: {
							url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/snapshots'),
							name: 'Auto-upload snapshot to RoscoLive',
							requestType: 'Post',
							postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
							type: 'WebRequestTemplate',
						},
						credentials: {
							database: data.database,
							userName: data.email,
							sessionId: data.sessionId,
						},
					}],
				)
			}

			if (notif_video_exist_id) {
				multicalls.push(
					['Set', {
						typeName: 'NotificationBinaryFile',
						entity: {
							id: notif_video_exist_id,
							url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/videos'),
							name: 'Auto-upload video to RoscoLive',
							requestType: 'Post',
							postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
							type: 'WebRequestTemplate',
						},
						credentials: {
							database: data.database,
							userName: data.email,
							sessionId: data.sessionId,
						},
					}],
				)
			} else {
				multicalls.push(
					['Add', {
						typeName: 'NotificationBinaryFile',
						entity: {
							url: getConvertedURL('https://geotab.roscolive.com/api/v1.0/geotab/custom_event/videos'),
							name: 'Auto-upload video to RoscoLive',
							requestType: 'Post',
							postBody: 'hash=3eebc8724325&database={database}&date={date}&time={time}&deviceid={deviceId}&device={device}&serial={serialNumber}&vin={vin}&rule={rule}&diagnostic={diagnostic}&driver={driverName}&driverfn={driverFirstName}&driverln={driverLastName}',
							type: 'WebRequestTemplate',
						},
						credentials: {
							database: data.database,
							userName: data.email,
							sessionId: data.sessionId,
						},
					}],
				)
			}

			geotabApi.multiCall(
				multicalls,
				(resMultiCall) => {
					console.log('!SET NotificationWebRequestTemplates resMultiCall: ', resMultiCall)
					toggleLoader(false);

					toastr.success('Success', i18n.t('components.adminSingleActions.credentialsSaved'))
				},
				(errorMultiCall) => {
					toggleLoader(false);
					console.log('!SET NotificationWebRequestTemplates error: ', errorMultiCall)

					if (errorMultiCall.message) {
						toastr.error(errorMultiCall.message)
					}
					else {
						toastr.error(errorMultiCall)
					}
				}
			)
		},
		(errCall) => {
			toggleLoader(false)
			console.log('!GET GetNotificationWebRequestTemplates errCall: ', data.email, errCall)
		})
	// } else {
	// 	toggleLoader(false);
	// }
	// })
}

const AdminSingleActions = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'components.adminSingleActions' });
	const { toggleLoader } = props;
	return (
		<main className='main-content-block'>
			<h3 className='category-title'>{t('titleNotRegularlyActions')}</h3>

			<div className="row form-group">
				<div className="col-md-4">
					<div className="upload-wrapper">
						<CustomButton variant="primary" onClick={e => handleAddInClick(e, 'addin', toggleLoader)} style={{ width: '100%' }}>{t('btnUpdateGeotabAdd-Ins')}</CustomButton>
					</div>
				</div>
				<div className="col-md-8">
					{t('makeUpdatesAdd-In')}
				</div>
			</div>

			<div className="row form-group">
				<div className="col-md-4">
					<div className="upload-wrapper">
						<CustomButton variant="primary" onClick={e => handleAddInClick(e, 'notifs', toggleLoader)} style={{ width: '100%' }}>{t('updateGeotabWebTemplate')}</CustomButton>
					</div>
				</div>
				<div className="col-md-8">
					{t('updatesWebRequestTemplate')}
				</div>
			</div>
		</main>
	)
}

export default connect(
	null,
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(AdminSingleActions);
